const en = {
  // My Offers
  catalogue_title_screen: 'My Offers',
  catalogue_title_section_recommended: 'Recommended for you',
  catalogue_title_section_filters: 'Filters',
  catalogue_label_recommended: 'Recommended for you',
  catalogue_label_filters_all: 'All',
  catalogue_label_something_went_wrong: 'Something went wrong',
  catalogue_action_retry: 'Try again',
  catalogue_action_retry_later: 'Try again later',
  catalogue_action_go_back: 'Go back',

  // Details
  catalogue_details_label_duration: ' %2$s',
  catalogue_details_label_validity: 'Validity',
  catalogue_details_label_show_more: 'Show more',
  catalogue_details_label_show_less: 'See less',
  catalogue_details_action_buy: 'Buy',

  // Payment
  catalogue_payment_type_airtime: 'Airtime',
  catalogue_payment_type_creditcard: 'Credit Card',
  catalogue_payment_type_bill: 'Send to bill',
  catalogue_payment_type_loan: 'Take Loan',
  catalogue_payment_step_select: 'Payment options',
  catalogue_payment_step_confirm: 'Activate bundle',
  catalogue_payment_step_loading: '',
  catalogue_payment_step_loan: 'Activate bundle',
  catalogue_payment_step_overwrite: 'Overwrite bundle',
  catalogue_payment_step_error: '',
  catalogue_payment_step_success: 'Bundle activation',
  catalogue_payment_label: 'Payment',
  catalogue_payment_label_payment_methods: 'Ways to pay',
  catalogue_payment_label_attention: 'Attention',
  catalogue_payment_label_cost: 'Cost ',
  catalogue_payment_label_congrats: 'Congratulations!',
  catalogue_payment_label_cta_p2h: 'Check now',
  catalogue_payment_label_cta_renewal: 'Check now',
  catalogue_payment_label_cta_refill: 'Activate now',
  catalogue_payment_label_cta_details: 'Activate now',
  catalogue_payment_label_cta_shake: 'Shake now',
  catalogue_payment_label_cta_flowerbox: 'Activate now',
  catalogue_payment_label_cta_topup: 'Activate now',
  catalogue_payment_label_cta_ebill: 'Pay now',
  catalogue_payment_label_cta_gigafamily: 'Check now',
  catalogue_payment_label_cta_tidal: 'Check now',
  catalogue_payment_label_cta_undefined: 'More',
  catalogue_payment_desc_bundle_activated: 'Your bundle was activated successfully.',
  catalogue_payment_desc_next_bill: 'You will be charged on your next bill',
  catalogue_payment_desc_activation_confirm: 'Are you sure you want to activate this bundle?',
  catalogue_payment_desc_overwrite: 'Activating %1$s bundle will overwrite one or more active bundles. Would you like to continue?',
  catalogue_payment_desc_loan_confirm: 'The loan and a fee of %1$s %2$s will be paid with your next recharge.',
  catalogue_payment_title_loan_confirm: 'Are you sure you want to activate this bundle by taking %1$s %2$s as a loan?',
  catalogue_payment_action_confirm: 'Confirm',
  catalogue_payment_action_back: 'Back',
  catalogue_payment_action_continue: 'Continue',
  catalogue_payment_action_overwrite: 'Overwrite',
  catalogue_payment_action_cancel: 'Cancel',
  catalogue_payment_price_unit: '%1$s %2$s',
  catalogue_payment_url_tidal: 'https://offers.vodafone.com/al',

  // Others
  addons_sub_text: '%1$s %2$s',
}

export default en
